
import { defineComponent } from 'vue'
import RdfResourceImpl from '@tpluscode/rdfine'
import { RuntimeOperation } from 'alcaeus'
import { GraphPointer } from 'clownface'

import { CsvSource } from '@cube-creator/model'

import { api } from '@/api'
import CsvUploadForm from '@/components/CsvUploadForm.vue'
import SidePane from '@/components/SidePane.vue'
import BMessage from '@/components/BMessage.vue'
import { displayToast } from '@/use-toast'
import { mapGetters, mapState } from 'vuex'

export default defineComponent({
  name: 'CSVReplaceView',
  components: { BMessage, CsvUploadForm, SidePane },

  data (): { error: string | null, isLoading: boolean } {
    return {
      error: null,
      isLoading: false,
    }
  },

  computed: {
    ...mapState('project', {
      mapping: 'csvMapping',
    }),
    ...mapGetters('project', {
      findSource: 'findSource',
    }),

    source (): CsvSource {
      const sourceId = this.$route.params.sourceId
      return this.findSource(sourceId)
    },

    operation (): RuntimeOperation {
      const operation = this.source.actions.replace

      if (!operation) throw new Error('Missing replace operation')

      return operation
    },

    fileMeta (): Record<string, string> {
      return {
        csvMapping: this.mapping.id.value,
        replace: this.source.id.value,
      }
    },
  },

  methods: {
    async submit (mediaObjects: GraphPointer[]): Promise<void> {
      const mediaObject = mediaObjects[0]

      const operation = this.operation
      const resource = RdfResourceImpl.factory.createEntity(mediaObject)

      this.error = null
      this.isLoading = true

      try {
        await api.invokeSaveOperation(operation, resource)

        displayToast({
          message: 'CSV file was successfully replaced',
          variant: 'success',
        })

        await this.close()
      } catch (e: any) {
        this.error = e?.details?.detail ?? e.toString()
        throw e
      } finally {
        this.isLoading = false
      }
    },

    async close (): Promise<void> {
      await this.$store.dispatch('project/refreshSourcesCollection')
      this.$router.push({ name: 'CSVMapping' })
    },
  },
})
